import { IProposta } from './IProposta';


export interface PropostasAgrupadas {
    [data: string]: IProposta[];
}


export function agruparPropostasPorData(propostas: IProposta[]): PropostasAgrupadas {
    const propostasAgrupadas: PropostasAgrupadas = {};

    propostas.forEach(proposta => {
        const dataParaAgrupar = proposta.data
            || proposta.criado
            || proposta.prazo_aceite
            || proposta.prazo_para_conclusao
            || proposta.modificado;

        if (!dataParaAgrupar) return;
        try {
            const dataAgrupamento = extrairDiaSemTimezone(dataParaAgrupar);
            if (!propostasAgrupadas[dataAgrupamento]) {
                propostasAgrupadas[dataAgrupamento] = [];
            }
            propostasAgrupadas[dataAgrupamento].push(proposta);
        } catch {
            console.warn(`Proposta ${proposta.id_proposta} ignorada por data inválida:`, proposta.data);
        }
    });

    const propostasOrdenadas: PropostasAgrupadas = {};
    Object.keys(propostasAgrupadas)
        .sort((a, b) => a.localeCompare(b))
        .forEach(data => {
            propostasOrdenadas[data] = propostasAgrupadas[data];
        });

    return propostasOrdenadas;
}

function extrairDiaSemTimezone(dataString: string): string {
    const matchIso = dataString.match(/^(\d{4}-\d{2}-\d{2})/);
    if (matchIso) return matchIso[1];

    const parsed = new Date(dataString);
    if (isNaN(parsed.getTime())) {
        throw new Error('Data inválida');
    }
    const year = parsed.getFullYear();
    const month = String(parsed.getMonth() + 1).padStart(2, '0');
    const day = String(parsed.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}


export function formatarDataExibicao(dataString: string): string {
    try {
        const data = new Date(dataString);
        return data.toLocaleDateString('pt-BR', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    } catch (error) {
        console.warn('Erro ao formatar data:', dataString, error);
        return dataString;
    }
}

